var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useEffect, useState } from 'react';
import { useLocale } from '@adsk/alloy-react-locale';
import { useAutocomplete, AutocompleteControl, } from '@adsk/alloy-react-dropdown';
import { LocationNameDisplay } from '../../LocationNameDisplay';
import LocationsDropdownTreeMenu from './LocationsDropdownTreeMenu';
export var LocationsDropdownTreeSingle = function (_a) {
    var selectedNodes = _a.selectedNodes, handleNodeSelectToggle = _a.handleNodeSelectToggle, selectLocationPlaceHolder = _a.selectLocationPlaceHolder, searchPlaceholder = _a.searchPlaceholder, isOpen = _a.isOpen, setIsOpen = _a.setIsOpen, _b = _a.searchTerm, searchTerm = _b === void 0 ? '' : _b, searchLocations = _a.searchLocations, getTreeNodeProps = _a.getTreeNodeProps, getTreeProps = _a.getTreeProps, useDropdownProps = _a.useDropdownProps, disabled = _a.disabled, container = _a.container, menuProps = __rest(_a, ["selectedNodes", "handleNodeSelectToggle", "selectLocationPlaceHolder", "searchPlaceholder", "isOpen", "setIsOpen", "searchTerm", "searchLocations", "getTreeNodeProps", "getTreeProps", "useDropdownProps", "disabled", "container"]);
    var T = useLocale(function (_a) {
        var locale = _a.locale;
        return require("../i18n/".concat(locale, ".json"));
    }).T;
    var _c = __read(useState(searchTerm), 2), inputValue = _c[0], setInputValue = _c[1];
    var handleInputChange = useCallback(function (_a) {
        var newInputValue = _a.inputValue;
        setInputValue(newInputValue);
        isOpen && searchLocations(newInputValue);
    }, [setInputValue, isOpen, searchLocations]);
    useEffect(function () {
        setInputValue(searchTerm);
    }, [searchTerm]);
    var onIsOpenChange = useCallback(function (_a) {
        var isOpen = _a.isOpen;
        setIsOpen(isOpen);
    }, [setIsOpen]);
    var _d = useAutocomplete(__assign(__assign({}, useDropdownProps), { 
        // Hack until useDropdownTree will be adjusted for single selection as well (currently returns items array only)
        // Setting null on isOpen because otherwise the value of the selected node persist in search box and used for filtering
        selectedItem: isOpen
            ? ''
            : (useDropdownProps.selectedItems && useDropdownProps.selectedItems[0]) ||
                '', 
        // overriding default filterring function to always return all items as we use onInputValueChange to filter items
        getFilteredItems: useCallback(function (_a) {
            var allItems = _a.allItems;
            return allItems;
        }, []), onInputValueChange: handleInputChange, inputValue: inputValue, isOpen: isOpen, onIsOpenChange: onIsOpenChange })), getInputProps = _d.getInputProps, getComboboxProps = _d.getComboboxProps, getToggleButtonProps = _d.getToggleButtonProps, getLabelProps = _d.getLabelProps, getMenuProps = _d.getMenuProps, menuItems = _d.menuItems, selectedItem = _d.selectedItem, targetProps = _d.targetProps, overlayProps = _d.overlayProps, openMenu = _d.openMenu;
    var localeSearchPlaceholder = searchPlaceholder || T.translate('locationPicker.searchPlaceholder');
    var localePlaceHolder = selectLocationPlaceHolder || T.translate('locationPicker.selectLocation');
    var getExtendedInputProps = useCallback(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (__assign(__assign({}, getInputProps.apply(void 0, __spreadArray([], __read(args), false))), { placeholder: localeSearchPlaceholder }));
    }, [getInputProps, localeSearchPlaceholder]);
    return (React.createElement("div", null,
        React.createElement(AutocompleteControl, { isOpen: isOpen, isDisabled: disabled, selectedItem: selectedItem, getToggleButtonProps: getToggleButtonProps, getLabelProps: getLabelProps, targetProps: targetProps, getComboboxProps: getComboboxProps, openMenu: openMenu, getInputProps: getExtendedInputProps, 
            // @ts-ignore: itemToString expects a string but we return a ReactNode type
            itemToString: function (node) { return (React.createElement(LocationNameDisplay, { locationNodeId: node.id })); }, placeholder: localePlaceHolder }),
        React.createElement(LocationsDropdownTreeMenu, __assign({ overlayProps: overlayProps, getMenuProps: getMenuProps, getTreeProps: getTreeProps, getTreeNodeProps: getTreeNodeProps, targetProps: targetProps, menuItems: menuItems, selectedNodes: selectedNodes, isOpen: isOpen, multiple: false, container: container }, menuProps))));
};
